import React, { useEffect, useState } from "react";
import { Tabs } from "antd";
import moment from "moment";
import arrowBack from "../../../assets/images/arrow-back.png";
import AppointmentRequest from "./AppointmentRequest";
import Notification from "./Notification";
import alert from "../../../assets/images/danger_alert.png";
import axiosInstance from "../../../axios/axios";
import { ModalDialog, DataDiv, Text, RowHead, Image } from "./styles";
import { Data } from "./chats/Style";
import { Row } from "./Message/styles";
import { globalColor, globalFont } from "../../utils/RepeatFunctions/Schedule";
import {
  Decrypt_Value,
  Encrypt_Value,
} from "../../../MiddleWare/EncryptDecrypt";
import { useHistory } from "react-router-dom";

// let storedNames = localStorage.getItem("setroles");

let storedNames = localStorage.getItem("setroles")
  ? Decrypt_Value(localStorage.getItem("setroles"), "vozo")
  : {};

const { TabPane } = Tabs;

const Notifications = (props) => {
  const history = useHistory();
  const loggedUserID = Decrypt_Value(localStorage.getItem("user_id"), "vozo");

  const [DataCount, setDataCount] = useState(props.appData);
  const [MsgCount, setMsgCount] = useState(0);
  const [count, setCount] = useState("0");
  const [actTab, setActTab] = useState("1");
  const dtFormat = localStorage.getItem("dateFormat");

  //  Existing treatment plan data
  const [treatmentPlans, setTreatmentPlans] = useState([]);

  //  NEW high risk data
  const [highRiskData, setHighRiskData] = useState([]);

  const [carePlanData, setCarePlanData] = useState([]);
  const [monitoringData, setMonitoringData] = useState([]);
  const [missedCallData, setMissedCallData] = useState([]);

  const [generalNotificationModal, setGeneralNotificationModal] = useState(
    props.genNotification,
  );

  //  MAIN FIX — merge both notifications
  // const mergedNotifications = [...treatmentPlans, ...highRiskData];
  const mergedNotifications = [
    ...(Array.isArray(missedCallData) ? missedCallData : []),

    ...(Array.isArray(treatmentPlans) ? treatmentPlans : []),

    ...(Array.isArray(highRiskData) ? highRiskData : []),

    ...(Array.isArray(carePlanData) ? carePlanData : []),

    ...(Array.isArray(monitoringData) ? monitoringData : []),
  ];

  const success = (val) => {
    setDataCount(val);
  };

  const getRiskLabel = (ranges, totalScore) => {
    console.log("Ranges:", ranges);
    if (!Array.isArray(ranges)) return "";

    const matchIndex = ranges.findIndex(
      ({ min, max }) => Number(totalScore) >= min && Number(totalScore) <= max,
    );

    if (matchIndex === -1) return "";

    // It's the baseline level, so don't show an alert

    // if (matchIndex === 0) return "";

    const match = ranges[matchIndex];
    if (!match || !match.label) return "";

    const lbl = match.label.toLowerCase();

    // Filter out non-critical levels (matching multi-scores logic)
    if (
      lbl.includes("no risk") ||
      lbl.includes("negative") ||
      lbl.includes("no identified") ||
      lbl.includes("no nicotine") ||
      lbl.includes("moderate") ||
      lbl.includes("mild") ||
      lbl.includes("low") ||
      lbl.includes("none") ||
      lbl.includes("minimal") ||
      lbl.includes("normal") ||
      lbl.includes("medium") ||
      lbl.includes("comfortable") ||
      lbl.includes("relaxed") ||
      lbl.includes("little") ||
      lbl.includes("relationship satisfaction")
    ) {
      return "";
    }

    return match.label;
  };

  const getUpdatedScores = (scores, scoringGuide) => {
    if (!Array.isArray(scores)) return scores || [];
    if (!scoringGuide || typeof scoringGuide !== "object") return scores;

    return scores.map((item) => {
      const ranges = scoringGuide[item.id];
      if (!Array.isArray(ranges)) return item;

      const matchIndex = ranges.findIndex(
        ({ min, max }) =>
          Number(item.score) >= min && Number(item.score) <= max,
      );
      const match = ranges[matchIndex];

      return {
        ...item,
        label: match?.label ?? item.label,
        description: match?.description ?? item.description,
        isFirstLevel: matchIndex === 0, // Mark if it's the lowest/baseline score
      };
    });
  };

  const handleactive = (activeKey) => {
    setActTab(activeKey);
    if (activeKey === "2") {
      axiosInstance
        .get("/vozo/patient/notification/data?type=remove&id=0")
        .then(() => {
          props.getNotify();
        })
        .catch((err) => {
          console.error(err.message);
        });
    }
  };

  const handleReviewPlan = async (planID, patID, plan) => {
    let payload = {
      isReviewed: 1,
      planId: planID,
      patientId: patID,
    };

    const handleCarePlanReview = async (row) => {
      try {
        await axiosInstance.post(
          "/vozo/update-care-plan-review",
          Encrypt_Value(
            {
              id: row.id,
              type: row.type,
            },
            "vozo",
          ),
        );

        history.push(`/patient/careplan/${row.pat_id}`, {
          planState: {
            planRow: row,
            planForm: true,
          },
          refreshKey: Date.now(),
        });

        props.changeDrop();
      } catch (err) {
        console.error(err);
      }
    };
    let encrypted = Encrypt_Value(payload, "vozo");

    try {
      await axiosInstance.put("/vozo/patient/updatetreatmentPlan", encrypted);
      history.push(`/patient/treatmentplan/${patID}`, {
        planState: { planRow: plan, planForm: true },
        refreshKey: Date.now(),
      });
      props.changeDrop();
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    setCount(props.notifyCount);
    setMsgCount(props.MsgCount);

    if (props.show === false) {
      setActTab("1");
      setGeneralNotificationModal(props.genNotification);
    }
  }, [props.MsgCount, props.show, props.count, props.genNotification]);

  const today = new Date();
  const formattedDate = `${String(today.getMonth() + 1).padStart(
    2,
    "0",
  )}-${String(today.getDate()).padStart(2, "0")}-${today.getFullYear()}`;

  return (
    <ModalDialog isGeneral={generalNotificationModal}>
      {generalNotificationModal ? (
        <>
          <Row borderBottom="1px solid #cbd5e0" padding="12px 16px">
            <RowHead color="#2C7BE5">
              <Image
                src={arrowBack}
                height="24px"
                width="24px"
                cursor="pointer"
                onClick={() => setGeneralNotificationModal(false)}
              />
              <span style={{ color: "#2C7BE5", marginLeft: "8px" }}>
                General Notification
              </span>
            </RowHead>
          </Row>

          <Row
            boxShadow="5px 5px 8px rgba(20, 46, 110, 0.15)"
            radius="8px"
            border="1px solid #cbd5e0"
            margin="8px"
          >
            <Data height="336px" width="100%">
              {mergedNotifications.length === 0 ? (
                <DataDiv mt="5px">
                  <Text
                    fontFamily={globalFont}
                    fontWeight="500"
                    fontSize="14px"
                    color="rgba(46,46,46,0.75)"
                    justifyContent="center"
                  >
                    No New Notification
                  </Text>
                </DataDiv>
              ) : (
                mergedNotifications.map((row, ind) => (
                  <DataDiv
                    key={ind}
                    padding="12px 12px 12px 16px"
                    bb="1px solid #cbd5e0"
                    cursor="pointer"
                    onClick={async () => {
                      if (row.type === "screening") {
                        if (row.pat_id && row.form_id) {
                          try {
                            await axiosInstance.get(
                              `/vozo/patient/notification/data?type=activity&id=${row.id}`,
                            );

                            history.push(
                              `/scoreboard/${row.pat_id}/${row.form_id}`,
                            );
                            props.changeDrop();
                          } catch (err) {
                            console.error("High risk update error", err);
                          }
                        } else {
                          console.warn("Missing pat_id or form_id", row);
                        }
                        return;
                      }

                      if (storedNames.show_noti_viewOnly) {
                        alert("You only have view-only access.");
                      } else {
                        if (row.type === "missed_call") {
                          try {
                            await axiosInstance.put(
                              "/vozo/reports/twilio/missed-call-notifications/read",
                              Encrypt_Value(
                                {
                                  id: row.id,
                                  providerID: loggedUserID,
                                },
                                "vozo",
                              ),
                            );

                            history.push("/report/appointments", {
                              tabkey: "3",
                              callDirection: "inbound",
                            });

                            props.changeDrop();
                          } catch (err) {
                            console.error(
                              "Missed call notification error:",
                              err,
                            );
                          }

                          return;
                        }
                        // CARE PLAN NOTIFICATIONS
                        if (
                          row.type === "care_plan" ||
                          row.type === "goal_assigned" ||
                          row.type === "goal_end" ||
                          row.type === "goal_overdue" ||
                          row.type === "care_plan_end"
                        ) {
                          try {
                            await axiosInstance.post(
                              "/vozo/update-care-plan-review",
                              Encrypt_Value(
                                {
                                  id: row.id,
                                  type: row.type,
                                },
                                "vozo",
                              ),
                            );

                            const res = await axiosInstance.post(
                              "/vozo/patient/getcarePlan",
                              Encrypt_Value(
                                {
                                  patientId: row.pat_id,
                                  planId: row.id,
                                },
                                "vozo",
                              ),
                            );

                            const response = Decrypt_Value(res.data, "vozo");

                            history.push(`/patient/careplan/${row.pat_id}`, {
                              planState: {
                                planRow: response[0],
                                planForm: true,
                              },
                              refreshKey: Date.now(),
                            });

                            props.changeDrop();
                          } catch (err) {
                            console.error("Care plan notification error", err);
                          }
                        } else if (
                          row.type === "monitoring_schedule" ||
                          row.type === "monitoring_reminder"
                        ) {
                          await axiosInstance.post(
                            "/vozo/update-monitoring-review",
                            Encrypt_Value(
                              {
                                id: row.id,
                              },
                              "vozo",
                            ),
                          );

                          const res = await axiosInstance.post(
                            "/vozo/patient/getMonitoringActivities",
                            Encrypt_Value(
                              {
                                patientId: row.pat_id,
                                monitoringId: row.id,
                              },
                              "vozo",
                            ),
                          );

                          const response = Decrypt_Value(res.data, "vozo");

                          history.push(`/patient/monitoring/${row.pat_id}`, {
                            monitoringState: {
                              monitoringRow: response[0],
                              monitoringForm: true,
                            },
                            refreshKey: Date.now(),
                          });

                          props.changeDrop();
                        } else {
                          handleReviewPlan(row.id, row.pat_id, row);
                        }
                      }
                    }}
                  >
                    {/* HEADER */}
                    <DataDiv display="flex">
                      <DataDiv
                        textAlign="center"
                        br="40px"
                        height="24px"
                        width="24px"
                        mr="8px"
                        background="#A8AEBE"
                      >
                        <Text
                          fontFamily={globalFont}
                          fontWeight="500"
                          fontSize="14px"
                          color="#fff"
                        >
                          {(row.pov_name || row.provider_name)?.charAt(0)}
                        </Text>
                      </DataDiv>

                      <Text fontFamily={globalFont} mr="20px">
                        {row.pov_name || row.provider_name}
                      </Text>

                      <Text fontFamily={globalFont} color="#2C7BE5">
                        {row.type === "screening"
                          ? moment(row.assessment_date).format(
                              dtFormat || "MM-DD-YYYY",
                            )
                          : formattedDate}
                      </Text>
                    </DataDiv>

                    {/* BODY */}
                    <DataDiv mt="5px">
                      {row.type === "screening" ? (
                        <>
                          {row.severity &&
                            row.score_display &&
                            getRiskLabel(row.scoring_guide, row.total_score) !==
                              "" && (
                              <>
                                <Text
                                  fontWeight="600"
                                  textTransform="capitalize"
                                >
                                  <span>
                                    <Image src={alert} />
                                  </span>{" "}
                                  {getRiskLabel(
                                    row.scoring_guide,
                                    row.total_score,
                                  )}{" "}
                                  patient alert ({row.score_display})
                                </Text>
                                <Text
                                  fontSize="13px"
                                  color="rgba(46,46,46,0.75)"
                                  mt="5px"
                                >
                                  A high risk assessment result has been
                                  recorded for{" "}
                                  <span style={{ color: "#2C7BE5" }}>
                                    {row.assessment}
                                  </span>
                                </Text>
                              </>
                            )}
                          {row?.scores &&
                            row?.scores.length > 0 &&
                            getUpdatedScores(
                              (() => {
                                let scrs = row.scores;
                                let calcs = row.calculations;
                                if (typeof calcs === "string") {
                                  try {
                                    calcs = JSON.parse(calcs);
                                  } catch (e) {
                                    calcs = null;
                                  }
                                }
                                if (calcs && Array.isArray(calcs)) {
                                  const gaugeIds = calcs
                                    .filter((c) => c.display === "gauge")
                                    .map((c) => c.id);
                                  if (gaugeIds.length > 0) {
                                    scrs = scrs.filter((s) =>
                                      gaugeIds.includes(s.id),
                                    );
                                  }
                                }
                                return scrs;
                              })(),
                              row.scoring_guide,
                            )
                              .filter((score) => {
                                // If we successfully matched it to the scoring guide,
                                // simply exclude it if it's the first level (baseline/negative).
                                // if (score.isFirstLevel) return false;

                                // If a score has no label/severity attached to it (like the extra OCI-R subscales), exclude it.
                                if (!score.label) return false;

                                // Fallback string check just in case scoring_guide was missing
                                const lbl = score.label.toLowerCase();
                                if (
                                  lbl.includes("no risk") ||
                                  lbl.includes("negative") ||
                                  lbl.includes("no identified") ||
                                  lbl.includes("no nicotine") ||
                                  lbl.includes("moderate") ||
                                  lbl.includes("mild") ||
                                  lbl.includes("low") ||
                                  lbl.includes("none") ||
                                  lbl.includes("minimal") ||
                                  lbl.includes("normal") ||
                                  lbl.includes("medium") ||
                                  lbl.includes("comfortable") ||
                                  lbl.includes("relaxed") ||
                                  lbl.includes("little") ||
                                  lbl.includes("relationship satisfaction")
                                ) {
                                  return false;
                                }

                                return true;
                              })
                              .filter(
                                (score, index, self) =>
                                  index ===
                                  self.findIndex(
                                    (s) =>
                                      s.description === score.description &&
                                      s.score_display === score.score_display,
                                  ),
                              )
                              .map((score, index, filteredArr) => (
                                <>
                                  <Text
                                    fontWeight="600"
                                    textTransform="capitalize"
                                    mt={index === 0 ? "0" : "10px"}
                                    display="inline-flex"
                                    gap="5px"
                                    verticalAlign="middle"
                                  >
                                    <span>
                                      <Image src={alert} />
                                    </span>{" "}
                                    <p>
                                      {score?.description?.split(".")[0] ||
                                        "High Risk"}{" "}
                                      patient alert ({score?.score_display})
                                    </p>
                                  </Text>
                                  {index === filteredArr.length - 1 && (
                                    <Text
                                      fontSize="13px"
                                      color="rgba(46,46,46,0.75)"
                                      mt="5px"
                                    >
                                      A high risk assessment result has been
                                      recorded for{" "}
                                      <span style={{ color: "#2C7BE5" }}>
                                        {row.assessment}
                                      </span>
                                    </Text>
                                  )}
                                </>
                              ))}
                        </>
                      ) : row.type === "missed_call" ? (
                        <>
                          <Text
                            fontSize="13px"
                            color="rgba(233, 45, 45, 0.75)"
                            mt="5px"
                          >
                            {row.patient_name
                              ? `You missed a call from ${row.patient_name}.`
                              : "You have a missed call."}
                          </Text>
                          {row.from_number && (
                            <Text
                              fontSize="12px"
                              color="rgba(46,46,46,0.50)"
                              mt="5px"
                            >
                              Phone: {row.from_number}
                            </Text>
                          )}

                          {row.start_time && (
                            <Text
                              fontSize="12px"
                              color="rgba(46,46,46,0.50)"
                              mt="5px"
                            >
                              Time:{" "}
                              {moment(row.start_time).format(
                                "MM-DD-YYYY hh:mm A",
                              )}
                            </Text>
                          )}
                        </>
                      ) : (
                        <>
                          <Text fontWeight="600">
                            {row.title ||
                              "Patient treatment plan is awaiting your review"}
                          </Text>

                          <Text
                            fontSize="13px"
                            color="rgba(46,46,46,0.75)"
                            mt="5px"
                          >
                            {row.description || ""}
                          </Text>
                        </>
                      )}
                    </DataDiv>
                  </DataDiv>
                ))
              )}
            </Data>
          </Row>
        </>
      ) : (
        <>
          <DataDiv
            ml="188px"
            minWidth="16px"
            justifyContent="center"
            display="flex"
            aspectRatio="1/1"
            MaxWidth="24px"
            background={globalColor}
            br="50px"
            position="absolute"
            mt="8px"
          >
            <Text
              textAlign="center"
              fontFamily={globalFont}
              fontWeight="500"
              fontSize="12px"
              color="#ffffff"
              lineHeight="15px"
              height="100%"
              display="flex"
            >
              {DataCount.length}
            </Text>
          </DataDiv>
          <DataDiv
            ml="310px"
            minWidth="16px"
            justifyContent="center"
            alignItems="center"
            display="flex"
            aspectRatio="1/1"
            MaxWidth="24px"
            background={globalColor}
            br="50px"
            position="absolute"
            mt="8px"
          >
            <Text
              textAlign="center"
              fontFamily={globalFont}
              fontWeight="500"
              fontSize="12px"
              color="#ffffff"
              lineHeight="15px"
              height="100%"
              display="flex"
            >
              {MsgCount + props.refillCount}
            </Text>
          </DataDiv>
          <Tabs activeKey={actTab} onChange={(k) => handleactive(k)}>
            <TabPane tab="Appointment Requests" key="1">
              <AppointmentRequest
                appData={props.appData}
                success={success}
                show={props.show}
                calRefHandle={props.calRefHandle}
                successreload={props.successreload}
              />
            </TabPane>

            <TabPane tab="Notifications" key="2">
              <Notification
                dropChange={props.changeDrop}
                count={count}
                setGeneralNotificationModal={setGeneralNotificationModal}
                setTreatmentPlans={setTreatmentPlans}
                setHighRiskData={setHighRiskData}
                setCarePlanData={setCarePlanData}
                setMonitoringData={setMonitoringData}
                missedCallData={missedCallData}
                setMissedCallData={setMissedCallData}
                refillCount={props.refillCount}
              />
            </TabPane>
          </Tabs>
        </>
      )}
    </ModalDialog>
  );
};

export default Notifications;
